import { GlobalConfigService } from "./../../../../../../services/global-config/global-config.service";
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  BroadcastService,
  LocalizationService,
  MibpLogger,
} from "root/services";
import { Subscription, firstValueFrom, skip } from "rxjs";
import { DashboardNewsArticleViewModel } from "root/mibp-openapi-gen/models";
import { LogService } from "root/services/logservice";
import { HttpCancellactionService } from "root/services/http-cancellation/http-cancellation.service";

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { MibpNewsCarouselComponent } from 'root/modules/home/modules/home-dashboard/components/news-carousel/news-carousel.component';
import { LoaderComponent } from 'root/shared/components/status/loader/loader.component';
import { EcommerceRouterLinkDirective } from 'root/directives/ecommerce-router-link/ecommerce-router-link.directive';
import { newsArticleFnGetNewsArticlesForDashboard } from "root/mibp-openapi-gen/fn/news-article/news-article-fn-get-news-articles-for-dashboard";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Component({
  selector: "mibp-dashboard-latest-news",
  templateUrl: "./dashboard-latest-news.component.html",
  styleUrls: ["./dashboard-latest-news.component.scss"],
  providers: [HttpCancellactionService],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, MibpNewsCarouselComponent, LoaderComponent, EcommerceRouterLinkDirective]
})
export class MibpDashboardLatestNewsComponent implements OnInit, OnDestroy {
    private mibpApiService = inject(MibpApiService);
  private broadcast = inject(BroadcastService);
  private globalConfig = inject(GlobalConfigService);
  private localizationService = inject(LocalizationService);
  private httpCancellation = inject(HttpCancellactionService);

  newsArticles: DashboardNewsArticleViewModel[];
  isLoading = false;
  hasError = false;
  actAsSub: Subscription;
  isDynamicdashboard = false;
  log: MibpLogger;
  localeSub: Subscription;
  currentLanguage: string;

  constructor() {
    const logger = inject(LogService);

    this.log = logger.withPrefix(`dashboard-tile-latest-news`);
  }

  ngOnInit(): void {
    this.currentLanguage = this.localizationService.getLang();
    this.actAsSub = this.broadcast.deliverySequence.subscribe(() =>
      this.load()
    );
    this.isDynamicdashboard = this.globalConfig.activateDynamicDashboard;

    this.localeSub = this.localizationService.Locale$.pipe(skip(1)).subscribe(
      () => {
        if (this.currentLanguage != this.localizationService.getLang()) {
          this.currentLanguage = this.localizationService.getLang();
          this.isLoading = true;
          this.load();
        }
      }
    );
  }

  async load(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;
    try {
      const result = await this.httpCancellation.singleValueFrom(
        this.mibpApiService.invoke(newsArticleFnGetNewsArticlesForDashboard, {
                    languageCode: this.currentLanguage,
                  })
      );

      this.newsArticles = result;
      this.isLoading = false;
    } catch (error) {
      this.log.error("error getting news articles", error);
      this.hasError = true;
      this.isLoading = false;
    }
  }

  ngOnDestroy(): void {
    this.actAsSub?.unsubscribe();
  }
}
